<template>
  <ListView
    modelName="Counterpart"
    perm="master.menu_counterpart"
    :items.sync="items"
    :params.sync="params"
    title="menu_counterpart"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="Counterpart"
    :gridCaptions="['状態','ワークフロー', 'コード', '名称', '取引先種別', '郵便番号', '住所1', '住所2', '住所3', '電話番号', 'FAX番号', '担当部署名', '担当者', '敬称', '補助科目コード(BS)', '補助科目コード(PL)', '得意先',  'category_1', 'category_2', 'category_3', 'category_4', 'category_5', 'category_6', '初回保存日', '初回保存者 ', '最終更新日', '最終更新者']"
    :gridWidths="[100,180, 170, 250, 150, 150, 150, 150, 150, 150, 150, 150, 150, 50, 150, 150, 150, 200, 150, 150, 150, 150,  150, 150, 150, 150, 150]"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    @selected="onSelected"
    :comparer="(a,b)=>a.id == b.id"
    tooltip="得意先・仕入先・納入先・倉庫を登録します。基本情報タブでは、対外帳票に出力される住所などの情報を設定します。"
    :popup="popup"
  >
    <!-- 明細項目の配置 -->
    <GridItem slot="grid0" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
    <GridItem slot="grid1" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>    
    <GridItem slot="grid2" slot-scope="{ item }">{{ item.code }}</GridItem>
    <GridItem slot="grid3" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.name }}</GridItem>
    <GridItem slot="grid4" slot-scope="{ item }">{{ item.counterpartType | counterpartTypes }}</GridItem>
    <GridItem slot="grid5" slot-scope="{ item }">{{ item.postalCode }}</GridItem>
    <GridItem slot="grid6" slot-scope="{ item }">{{ item.address1 }}</GridItem>
    <GridItem slot="grid7" slot-scope="{ item }">{{ item.address2 }}</GridItem>
    <GridItem slot="grid8" slot-scope="{ item }">{{ item.address3 }}</GridItem>
    <GridItem slot="grid9" slot-scope="{ item }">{{ item.telNo }}</GridItem>
    <GridItem slot="grid10" slot-scope="{ item }">{{ item.faxNo }}</GridItem>
    <GridItem slot="grid11" slot-scope="{ item }">{{ item.picSection }}</GridItem>
    <GridItem slot="grid12" slot-scope="{ item }">{{ item.pic }}</GridItem>
    <GridItem slot="grid13" slot-scope="{ item }">{{ item.honorificTitle }}</GridItem>
    <GridItem slot="grid14" slot-scope="{ item }">{{ item.mappingCodeBS }}</GridItem>
    <GridItem slot="grid15" slot-scope="{ item }">{{ item.mappingCodePL }}</GridItem>    
    <GridItem slot="grid16" slot-scope="{ item }">{{ item.customer?item.customer.name:'' }}</GridItem>    
    <GridItem slot="grid17" slot-scope="{ item }">{{ item.category1 | category_1 }}</GridItem>
    <GridItem slot="grid18" slot-scope="{ item }">{{ item.category2 | category_2 }}</GridItem>
    <GridItem slot="grid19" slot-scope="{ item }">{{ item.category3 | category_3 }}</GridItem>
    <GridItem slot="grid20" slot-scope="{ item }">{{ item.category4 | category_4 }}</GridItem>
    <GridItem slot="grid21" slot-scope="{ item }">{{ item.category5 | category_5 }}</GridItem>
    <GridItem slot="grid22" slot-scope="{ item }">{{ item.category6 | category_6 }}</GridItem>
    <GridItem slot="grid23" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem slot="grid24" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem slot="grid25" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem slot="grid26" slot-scope="{ item }">{{ item.lastUpdatedBy | user }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView">
        <ListViewMenu slot="file_layout_download" icon="file_download" title="インポートファイル"  @click="showDownloadImportFileDialog" tooltip="各種インポート用のレイアウトファイルをダウンロードします。" />
        <!-- <ListViewMenu slot="file_layout_download" icon="file_download" title="得意先インポートレイアウト"  @click="$api.fileDownload('https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E5%BE%97%E6%84%8F%E5%85%88(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx')" tooltip="得意先情報インポート用のレイアウトファイルをダウンロードします。" /> -->
        <!-- <ListViewMenu slot="file_layout_download" icon="file_download" title="仕入先インポートレイアウト"  @click="$api.fileDownload('https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E4%BB%95%E5%85%A5%E5%85%88(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx')" tooltip="仕入先情報インポート用のレイアウトファイルをダウンロードします。" /> -->
        <!-- <ListViewMenu slot="file_layout_download" icon="file_download" title="納入先インポートレイアウト"  @click="$api.fileDownload('https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E7%B4%8D%E5%85%A5%E5%85%88(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx')" tooltip="納入先情報インポート用のレイアウトファイルをダウンロードします。" /> -->
        <!-- <ListViewMenu slot="file_layout_download" icon="file_download" title="倉庫インポートレイアウト"  @click="$api.fileDownload('https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E5%80%89%E5%BA%AB(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx')" tooltip="倉庫情報インポート用のレイアウトファイルをダウンロードします。" /> -->
      </ListViewMenuBar>
    　<b-modal v-model="showDownloadImportFile" title="インポートファイルダウンロード" @ok="onImportFileDownload" :no-close-on-backdrop="true" centered v-if="showDownloadImportFile" :ok-only='false' >
          <ComboBox title="取引先種別" :value.sync="dlCounterpartType" list="counterpartTypes"/>
      </b-modal>
    </template>
    <!-- サブタイトルの配置 -->
    <!-- <template slot="title"><span style="white-space:nowrap;" v-if="$api.spMode == false">(得意先・仕入先・納入先・倉庫)</span></template>     -->
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">
        <FilterBox title="コード" :value.sync="params.code" @click="handler" />
        <FilterBox title="名称" :value.sync="params.name" @click="handler" />
        <ComboBox title="取引先種別" :value.sync="params.counterpartType" list="counterpartTypes" @changed="handler"/>
        <AutoComplete title="category_1" :value.sync="params.category1" list="category_1" @changed="handler" />
        <AutoComplete title="category_2" :value.sync="params.category2" list="category_2" @changed="handler" />
        <AutoComplete title="category_3" :value.sync="params.category3" list="category_3" @changed="handler" />
        <AutoComplete title="category_4" :value.sync="params.category4" list="category_4" @changed="handler" />
        <AutoComplete title="category_5" :value.sync="params.category5" list="category_5" @changed="handler" />
        <AutoComplete title="category_6" :value.sync="params.category6" list="category_6" @changed="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />          
        <ComboBox title="状態" :value.sync="params.state" list="masterBaseStatus" @changed="handler" />        
    </Search>
    </template>
    <!-- エディタの配置 -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報', '請求設定', '支払設定', '振込連携設定', 'その他設定', '貿易設定','帳票設定' ,  '予備項目','ワークフロー','更新履歴']" :tabVisibles="tabVisibles"  :tabTooltips="[null,null,null,null,null,null,null,'【テナント設定】>【取引先予備項目】から項目名を任意に変更することができます。ここで入力した内容は各伝票の予備項目に設定されます。']">
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <!-- <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="workflowRequired(item)" :enabled="workflowRequired(item)" :nullValue="0" /> -->
              <TextBox title="コード" :value.sync="item.code" :editor="editor" :required="true" :enabled="listView.isInsertMode || tenantSettings.allowChangeCounterpartCode" length="25" tooltip="取引先データを管理するコードを最大25文字までで入力します。同じ取引先コードは登録できません。<br>※1度保存すると変更できません。" />
              <TextBox title="名称" :value.sync="item.name" :editor="editor" :required="true" length="50" tooltip="取引先の名前を最大50文字まで入力できます。ここに登録した値が各一覧画面の取引先欄に表示されます。" />
              <RadioButton title="取引先種別" :value.sync="item.counterpartType" :editor="editor" list="counterpartTypes" @update:value="onCounterpartTypeChanged(item)" :isDirectEditEnabled="false"  :enabled="isNotPosted(item)" :disabled="popupCounterpartTypeDisabled" rows="2" tooltip="取引先の種類を登録します。<br>※1度確定すると変更できません。変更したい場合は新しい取引先を登録します。この項目が複数必要な取引先は、別のコードで登録します。" />
              <div style="display:flex;">
                <TextBox title="郵便番号" :value.sync="item.postalCode" :editor="editor" length="50" tooltip="任意で取引先の郵便番号を最大50文字まで入力できます。" />
                <Button class="button cx_itembutton" style="margin-left:10px"  @click="$api.getAddress(item.postalCode).then(res => item.address1 = res)" caption="住所取得" :disabled="!editor.isEdit" tooltip="郵便番号から住所を取得します"/>
              </div>              
              <TextBox title="住所1" :value.sync="item.address1" :editor="editor" length="50" tooltip="取引先の住所を任意の区切りで最大50文字まで入力できます。" />
              <TextBox title="住所2" :value.sync="item.address2" :editor="editor" length="50" tooltip="取引先の住所を任意の区切りで最大50文字まで入力できます。" />
              <TextBox title="住所3" :value.sync="item.address3" :editor="editor" length="50" tooltip="取引先の住所を任意の区切りで最大50文字まで入力できます。" />
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <TextBox title="電話番号" :value.sync="item.telNo" :editor="editor" length="20" tooltip="任意で取引先の電話番号を最大20文字まで入力できます。" />
              <TextBox title="FAX番号" :value.sync="item.faxNo" :editor="editor" length="20" tooltip="任意で取引先のFAX番号を最大20文字まで入力できます。" />
              <TextBox title="担当部署名" :value.sync="item.picSection" :editor="editor" length="50" tooltip="任意で取引先担当者の部署を最大50文字まで入力できます。" />
              <TextBox title="担当者" :value.sync="item.pic" :editor="editor" length="30" tooltip="任意で取引先の担当者名を最大30文字まで入力できます。" />
              <TextBox title="敬称" :value.sync="item.honorificTitle" :editor="editor" length="5" tooltip="帳票出力やメール送信をする際に表示される敬称です。" />
              <TextBox title="担当者メール" :value.sync="item.picMail" :editor="editor" length="200"  v-if="isCustomerOrSupplierOrWarehouse(item)" tooltip="任意で取引先の担当者メールアドレスを最大200文字まで入力できます。※複数指定可(カンマ区切り)" />              
              <!-- <TextBox title="状態" :value="item.state | masterBaseStatus" :editor="editor" :enabled="false" />
              <TextBox title="所有者" :value="item.holder | user" :editor="editor" :enabled="false" /> -->
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="取引先データを最後に更新した日時が表示されています。" />
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="$api.perms.hasWorkflow('masterBase')" :enabled="$api.perms.hasWorkflow('masterBase') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="マスタ登録用のワークフローを指定します。【フロー区分】が【マスタ管理】になっているデータから選択ができます。" />
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="取引先データの現在の状態が表示されており､ワークフロー欄の確定や使用停止ボタンをクリックすることで変化します。" />
            </template>
          </EditPanel>
        </template>
        <!-- 請求設定タブ -->
        <template slot="tab1" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 請求設定タブ 左側 -->
            <template slot="left">
              <ComboBox title="請求区分" :value.sync="item.invoiceType" :editor="editor" list="salesInvoiceTypes" :required="isCustomer(item)" :enabled="isCustomer(item) && isNotPosted(item)" :nullValue="0" :isDirectEditEnabled="false" tooltip="請求方法を【締請求】【個別請求】から選択します。<br>※1度確定すると変更できません。" />
              <RadioButton title="支払日区分" :value.sync="item.paymentDateType" :editor="editor" list="paymentDateTypes" :required="paymentDateTypeRequired(item)" :enabled="paymentDateTypeRequired(item)" :isDirectEditEnabled="false" tooltip="支払日の初期値の算出方法を【締日指定】【日数指定】から選択します。【請求区分】が【個別請求】の時のみ選択でき、それ以外は【締日指定】で固定となります。" />
              <ComboBox title="締日１" :value.sync="item.closingDate1" :editor="editor" list="dateTypes" :required="closingDateRequired(item)" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="請求の締日を入力します。請求処理を行ったときに【売上日】に最初に出てくる日付をこの項目で設定します。" />
              <ComboBox title="支払日１" :value.sync="item.dueDate1" :editor="editor" list="dateTypes" :required="closingDateRequired(item)" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="請求の支払日を入力します。請求処理を行ったときに【入金予定日】に最初に出てくる日付をこの項目で設定します。" />
              <ComboBox title="支払月１" :value.sync="item.paymentMonth1" :editor="editor" list="monthTypes" :required="closingDateRequired(item)" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="請求の支払月を入力します。請求処理を行ったときに【入金予定日】に最初に出てくる日付をこの項目で設定します。" />
              <ComboBox title="締日２" :value.sync="item.closingDate2" :editor="editor" list="dateTypes" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="締日が2パターンある場合に､2つ目の請求の締日を入力します。請求処理を行ったときに【売上日】に最初に出てくる日付をこの項目で設定できます。" />
              <ComboBox title="支払日２" :value.sync="item.dueDate2" :editor="editor" list="dateTypes" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="締日が2パターンある場合に､2つ目の請求の支払日を入力します。請求処理を行ったときに【入金予定日】に最初に出てくる日付をこの項目で設定できます。" />
              <ComboBox title="支払月２" :value.sync="item.paymentMonth2" :editor="editor" list="monthTypes" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="締日が2パターンある場合に､2つ目の請求の支払月を入力します。請求処理を行ったときに【入金予定日】に最初に出てくる日付をこの項目で設定できます。" />
              <NumericBox title="支払日数" :value.sync="item.paymentSite" :editor="editor" v-if="paymentSiteRequired(item)" min="0" max="999" tooltip="売上日から入金予定日までの日数を入力します。請求処理を行ったときに【入金予定日】に最初に出てくる日付をこの項目で設定できます。" />
              <!-- <AtcCounterpart title="支払先" :value.sync="item.payee" :editor="editor" :needsSupplier="true" :enabled="isSupplierOrWarehouse(item)" /> -->
            </template>
            <!-- 請求設定タブ 右側 -->
            <template slot="right">        
              <AutoComplete title="請求口座" :value.sync="item.customerBankAccountCode" :editor="editor" list="bankAccount"  :enabled="isCustomer(item)" tooltip="取引先から入金してもらう自社の口座を指定することができます。" path="/master/BankAccount"/>
              <TextBox title="決済条件" :value.sync="item.paymentTerm" :editor="editor" :enabled="isCustomerOrSupplierOrWarehouse(item)" length="50" tooltip="決済に関わる条件として、50文字以内で任意の値を設定することができます。この項目は各伝票の【決済条件】の初期値となります。" />
              <AtcCounterpart title="請求先" :value.sync="item.payer" :editor="editor" :needsCustomer="true" :enabled="isCustomer(item)" tooltip="複数の得意先を一つの請求先にまとめることができます。ここで入力した得意先宛に請求データが作成されます。" />
              <ComboBox title="決済方法" :value.sync="item.settlement" :editor="editor" list="invoiceSettlementTypes" :required="true" :showDefault="false" tooltip="取引先に対する請求を【売掛】か【現金】か設定することができます。請求情報の【決済方法】の初期値となります。" />
              <TextBox title="口座名義(カナ)" :value.sync="item.accountName" :editor="editor" :enabled="isCustomer(item)" length="30" tooltip="こちらの設定値とMoneyLookから取得した入金データの備考もしくは摘要のデータを照合して、一致した場合にこの得意先の入金データとして取り込みます。" />
            </template>
          </EditPanel>
        </template>
        <!-- 支払設定タブ -->        
        <template slot="tab2" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 支払設定タブ 左側 -->
            <template slot="left">
              <RadioButton title="支払日区分" :value.sync="item.paymentDateType" :editor="editor" list="paymentDateTypes" :required="paymentDateTypeRequired(item)" :enabled="paymentDateTypeRequired(item)" tooltip="支払日の初期値の算出方法を【締日指定】【日数指定】から選択します。" />
              <ComboBox title="締日１" :value.sync="item.closingDate1" :editor="editor" list="dateTypes" :required="closingDateRequired(item)" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="仕入金額の締日を入力します。支払処理を行ったときに【支払日】に最初に出てくる日付をこの項目で設定します。" />
              <ComboBox title="支払日１" :value.sync="item.dueDate1" :editor="editor" list="dateTypes" :required="closingDateRequired(item)" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="仕入金額の支払日を入力します。支払処理を行ったときに【支払日】に最初に出てくる日付をこの項目で設定します。" />
              <ComboBox title="支払月１" :value.sync="item.paymentMonth1" :editor="editor" list="monthTypes" :required="closingDateRequired(item)" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="仕入金額の支払月を入力します。支払処理を行ったときに【支払日】に最初に出てくる日付をこの項目で設定します。" />
              <ComboBox title="締日２" :value.sync="item.closingDate2" :editor="editor" list="dateTypes" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="締日が2パターンある場合に､2つ目の仕入金額の締日を入力します。支払処理を行ったときに【支払日】に最初に出てくる日付をこの項目で設定できます。" />
              <ComboBox title="支払日２" :value.sync="item.dueDate2" :editor="editor" list="dateTypes" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="締日が2パターンある場合に､2つ目の仕入金額の支払日を入力します。支払処理を行ったときに【支払日】に最初に出てくる日付をこの項目で設定できます。" />
              <ComboBox title="支払月２" :value.sync="item.paymentMonth2" :editor="editor" list="monthTypes" v-if="closingDateRequired(item)" :nullValue="0" :showDefault="false" tooltip="締日が2パターンある場合に､2つ目の仕入金額の支払月を入力します。支払処理を行ったときに【支払日】に最初に出てくる日付をこの項目で設定できます。" />
              <NumericBox title="支払日数" :value.sync="item.paymentSite" :editor="editor" v-if="paymentSiteRequired(item)" min="0" max="999" tooltip="仕入日から支払日までの日数を入力します。支払処理を行ったときに【支払日】に最初に出てくる日付をこの項目で設定します。" />
            </template>
            <!-- 支払設定タブ 右側 -->
            <template slot="right">
              <TextBox title="銀行名称" :value.sync="item.bankName" :editor="editor" :enabled="isSupplierOrWarehouse(item)" length="15" tooltip="任意に15文字まで支払先の銀行名称を設定することができます。" />
              <TextBox title="銀行支店名称" :value.sync="item.bankBranchName" :editor="editor" :enabled="isSupplierOrWarehouse(item)" length="15" tooltip="任意に15文字まで支払先の銀行支店名称を設定することができます。" />
              <!-- <TextBox title="口座種別" :value.sync="item.accountType" :editor="editor" :enabled="isSupplierOrWarehouse(item)" length="10" tooltip="任意に10文字まで支払先の口座種別を設定することができます。" /> -->
              <ComboBox title="口座種別" :value.sync="item.accountCategory" list="bankAccountCategoryTypes" :nullValue="0" :editor="editor"  :required="item.useFirmBanking" :showDefault="false"  tooltip="支払先の口座種別を選択することができます。" />              
              <TextBox title="口座番号" :value.sync="item.accountCode" :editor="editor" :enabled="isSupplierOrWarehouse(item)" :required="item.useFirmBanking" length="7" tooltip="任意に7文字まで支払先の口座番号を設定することができます。"  regex="^[0-9]*$" regexMessage="数値以外は指定できません。" />
              <TextBox title="口座名義" :value.sync="item.accountName" :editor="editor" v-if="isSupplierOrWarehouse(item)" :required="item.useFirmBanking" length="30" regex='^[0-9A-Zｧ-ﾟ\(\)｢｣\/\-\.\\ ]*$' regexMessage="半角英数カナ一部記号のみ設定可能です。" tooltip="使用可能な文字は次の通りです。0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ()｢｣/-.\" />
              <TextBox title="決済条件" :value.sync="item.paymentTerm" :editor="editor" :enabled="isCustomerOrSupplierOrWarehouse(item)" length="50" tooltip="任意に50文字まで支払先の決済条件を設定することができます。" />
              <AtcCounterpart title="支払先" :value.sync="item.payee" :editor="editor" :needsSupplier="true" :enabled="isSupplierOrWarehouse(item)" tooltip="複数の仕入先を１つの支払先にまとめることができます。ここで入力した仕入先宛に支払データが作成されます。" />
            </template>
          </EditPanel>
        </template>        
        <!-- 全銀協設定タブ(削除。但しフィールドは残しておく) -->
        <template slot="tab3" slot-scope="{ editor, item }">
          <EditPanel>
            <template slot="left">
              <CheckBox title="振込データ連携" :value.sync="item.useFirmBanking" :editor="editor" list="isUse" :isDirectEditEnabled="false" tooltip="ネットバンキングで全銀ファイルによる支払処理を利用する場合はチェックをします。"/>
              <!-- <TextBox title="依頼人コード" :value.sync="item.companyRefCode" :editor="editor" :required="item.useFirmBanking" :enabled="item.useFirmBanking" length="10" :isDirectEditEnabled="item.useFirmBanking"  regex="^[0-9]*$" regexMessage="数値以外は指定できません。" tooltip="全銀ファイルに出力する依頼人コード(数値10文字まで)を設定します。"/>               -->
              <TextBox title="銀行コード" :value.sync="item.bankCode" :editor="editor" :required="item.useFirmBanking" :enabled="item.useFirmBanking" length="4" regex="^[0-9]*$" regexMessage="数値以外は指定できません。" tooltip="振込データ連携で出力する全銀ファイルに記載される銀行コード(数値4文字)を設定します。"/>
              <TextBox title="銀行名称(ｶﾅ)" :value.sync="item.bankNameKana" :editor="editor" :required="item.useFirmBanking" :enabled="item.useFirmBanking" length="15" regex="^[0-9A-Zｧ-ﾟ\(\)｢｣\/\-\.\\ ]*$" regexMessage="半角英数カナ一部記号のみ設定可能です。" tooltip="使用可能な文字は次の通りです。0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ()｢｣/-.\"/>
              <TextBox title="銀行支店コード" :value.sync="item.bankBranchCode" :editor="editor" :required="item.useFirmBanking" :enabled="item.useFirmBanking" length="3" regex="^[0-9]*$" regexMessage="数値以外は指定できません。"  tooltip="振込データ連携で出力する全銀ファイルに記載される銀行支店コード(数値3文字)を設定します。"/>
              <TextBox title="銀行支店名称(ｶﾅ)" :value.sync="item.bankBranchNameKana" :editor="editor" :required="item.useFirmBanking" :enabled="item.useFirmBanking" length="15" regex="^[0-9A-Zｧ-ﾟ\(\)｢｣\/\-\.\\ ]*$" regexMessage="半角英数カナ一部記号のみ設定可能です。" tooltip="使用可能な文字は次の通りです。0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ()｢｣/-.\"/>
              <!-- <TextBox title="口座名義(ｶﾅ)" :value.sync="item.bankAccountNameKana" :editor="editor" :required="item.useFirmBanking" :enabled="item.useFirmBanking" length="50" :isDirectEditEnabled="item.useFirmBanking" /> -->
              <!-- <TextBox title="依頼人名" :value.sync="item.companyRefName" :editor="editor" :required="item.useFirmBanking" :enabled="item.useFirmBanking" length="40" :isDirectEditEnabled="item.useFirmBanking" /> -->
            </template>
            <template slot="right">
            </template>
          </EditPanel>
        </template>        
        <!-- その他設定設定タブ -->
        <template slot="tab4" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- その他設定設定タブ 左側 -->
            <template slot="left">
              <RadioButton title="税計算区分" :value.sync="item.taxType" :editor="editor" list="taxTypes" :required="isCustomerOrSupplier(item)" v-if="isCustomerOrSupplierOrWarehouse(item)" :isDirectEditEnabled="false"  :enabled="isNotPosted(item)" tooltip="税計算の分類を登録します。【税抜】【税込】【対象外】から選択できます。<br>※1度確定すると変更できません。" />
              <AtcTaxCode title="税区分" :value.sync="item.taxCode" :taxType="item.taxType" :includeNoTax="false" :editor="editor" :required="isCustomerOrSupplier(item)" list="taxCode"  v-if="isCustomerOrSupplierOrWarehouse(item)" tooltip="税区分を選択します。【税区分一覧】に登録されているデータから選択でき、【税区分一覧】の【税計算区分】と一致する【税区分】をこの項目に選択します。" />
              <TextBox title="登録番号" :value.sync="item.invoiceNo" :editor="editor" v-if="isSupplier(item)" length="14" tooltip="適格請求書発行事業者の登録番号を設定できます。設定すると、発注・入荷一覧でご確認いただけます。<br>発行事業者とそれ以外で【税区分】を分けると「仕入元帳(税区分集計)」で集計できます。" />
              <AutoComplete title="取引先単価区分" :value.sync="item.priceCategory" :editor="editor" path="/master/Category"  list="category_101" v-if="isCustomerOrSupplier(item)" tooltip="商品マスタの【販売単価区分】が【単価マスタ】の場合、単価マスタの【取引先単価区分】と一致する単価を取得します。【区分一覧マスタ】＞【区分種別】が【取引先単価区分】のデータを選択できます。" />
              <TextBox title="補助科目コード(BS)" :value.sync="item.mappingCodeBS" :editor="editor" v-if="isCustomerOrSupplierOrWarehouse(item)" length="25" tooltip="ここで入力した値を【会計仕訳一覧】に補助科目コードとして表示させることができます。" />
              <TextBox title="補助科目コード(PL)" :value.sync="item.mappingCodePL" :editor="editor" v-if="isCustomerOrSupplierOrWarehouse(item)" length="25" tooltip="ここで入力した値を【会計仕訳一覧】に補助科目コードとして表示させることができます。" />
              <AutoComplete title="自社営業担当者" :value.sync="item.salesPerson" :editor="editor" list="user" v-if="isCustomer(item)" tooltip="【ユーザー】に登録されたデータから自社営業担当者を選択できます。" />
              <NumericBox title="販売単価掛率(％)" :value.sync="item.salesPricingRate" :editor="editor"  v-if="isCustomer(item)" decimals="2" min="0" max="999.99" tooltip="商品マスタの【販売単価区分】が【販売単価掛率】の場合、商品マスタの【上代単価】の金額から販売単価掛率を掛けた値を単価に設定することができます。" />
              <AtcCounterpart title="得意先" :value.sync="item.customer" :editor="editor" :needsCustomer="true" v-if="isReceiver(item)" tooltip="【取引先一覧】に登録されている【取引先種別】が【得意先】のデータを選択することができます。" />
              <AutoComplete title="通貨" :value.sync="item.currencyCode" list="currency" :editor="editor" :required="isCustomerOrSupplierOrWarehouse(item)" v-if="isCustomerOrSupplierOrWarehouse(item) && hasLicenseCurrency" />
              <!-- <TextBox title="連携コード" :value.sync="item.mappingCode" :editor="editor" length="20" />         -->
              <TextBox title="備考" :value.sync="item.description" :editor="editor" v-if="isCustomerOrSupplier(item)" length="200" rows="2" tooltip="任意に最大200文字まで、備考として値を設定することができます。この項目は各伝票の【備考】の初期値になります。" />
              <TextBox title="送り状請求先コード" :value.sync="item.forwarderInvoiceCode" :editor="editor" v-if="isWarehouse(item)" length="20"  tooltip="送り状データに出力する請求先コードを指定してください(クロネコヤマトのみ)" />            
              <TextBox title="送り状荷送人コード" :value.sync="item.consignorCode" :editor="editor" v-if="isWarehouse(item)" length="20"  tooltip="送り状データに出力する荷送人コードを指定してください(西濃運輸のみ)" />            
            </template>
            <!-- その他設定設定タブ 右側 -->
            <template slot="right">
              <AutoComplete title="category_1" :value.sync="item.category1" path="/master/Category"  list="category_1" :editor="editor" v-if="isCustomerOrSupplier(item)" :tooltip="'取引先を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_1')+'】のデータを選択できます。'" />
              <AutoComplete title="category_2" :value.sync="item.category2" path="/master/Category"   list="category_2" :editor="editor" v-if="isCustomerOrSupplier(item)" :tooltip="'取引先を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_2')+'】のデータを選択できます。'" />
              <AutoComplete title="category_3" :value.sync="item.category3" path="/master/Category"   list="category_3" :editor="editor" v-if="isCustomerOrSupplier(item)" :tooltip="'取引先を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_3')+'】のデータを選択できます。'" />
              <AutoComplete title="category_4" :value.sync="item.category4" path="/master/Category"   list="category_4" :editor="editor" v-if="isCustomerOrSupplier(item)" :tooltip="'取引先を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_4')+'】のデータを選択できます。'" />
              <AutoComplete title="category_5" :value.sync="item.category5" path="/master/Category"   list="category_5" :editor="editor" v-if="isCustomerOrSupplier(item)" :tooltip="'取引先を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_5')+'】のデータを選択できます。'" />
              <AutoComplete title="category_6" :value.sync="item.category6" path="/master/Category"   list="category_6" :editor="editor" v-if="isCustomerOrSupplier(item)" :tooltip="'取引先を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_6')+'】のデータを選択できます。'" />
              <TextBox title="連携コード" :value.sync="item.mappingCode" :editor="editor" length="255"  tooltip="連携先システムで使用している取引先のコードを指定します。"/>
              <TextBox title="特記事項" :value.sync="item.remark" :editor="editor" v-if="isCustomerOrSupplier(item)" length="200" rows="2" tooltip="任意に最大200文字まで、特記事項を入力することができます。この項目は各伝票の【特記事項】の初期値になります。" />
            </template>
          </EditPanel>
        </template>        
        <!-- 貿易書類設定タブ -->
        <template slot="tab5" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 貿易書類設定タブ 左側 -->
            <template slot="left">
              <template v-if="hasLicenseImport || hasLicenseExport">
                <ComboBox title="商品表記" :value.sync="item.commodityName" :editor="editor" list="commodityNameTypes" :showDefault="false" :required="isCustomerOrSupplier(item)" v-if="isCustomerOrSupplier(item)" />                
                <TextBox title="建値" :value.sync="item.deliveryTerm" :editor="editor" v-if="isCustomerOrSupplier(item)" length="15" />
                <TextBox title="受渡場所" :value.sync="item.deliveryLocation" :editor="editor" v-if="isCustomerOrSupplier(item)" length="50" />
                <ComboBox title="輸送方法" :value.sync="item.transportation" :editor="editor" list="transportationTypes" v-if="isSupplier(item)" />                
              </template>
              <template v-if="hasLicenseExport">
                <TextBox title="荷受地" :value.sync="item.receiptPlace" :editor="editor" v-if="isCustomerOrReceiver(item)" length="30" />
                <TextBox title="積地港" :value.sync="item.loadingPort" :editor="editor" v-if="isCustomerOrReceiver(item)" length="30" />
                <TextBox title="荷揚港" :value.sync="item.dischargePort" :editor="editor" v-if="isCustomerOrReceiver(item)" length="30" />
                <TextBox title="荷渡地" :value.sync="item.deliveryPlace" :editor="editor" v-if="isCustomerOrReceiver(item)" length="30" />
                <TextBox title="仕向国" :value.sync="item.countryOfDestination" :editor="editor" v-if="isCustomerOrReceiver(item)" length="30" />
                <TextBox title="運賃負担" :value.sync="item.payFreight" :editor="editor" v-if="isCustomerOrReceiver(item)" length="30" />
              </template>
            </template>
            <!-- 貿易書類設定タブ 右側 -->
            <template slot="right">
              <template v-if="hasLicenseImport">
                <TextBox title="Ship-via" :value.sync="item.shipVia" :editor="editor" v-if="isSupplier(item)" length="50"/>
                <TextBox title="Insurance" :value.sync="item.insurance" :editor="editor" v-if="isSupplier(item)" length="50" />
                <TextBox title="Ship-to" :value.sync="item.shipTo" :editor="editor" v-if="isSupplier(item)" length="200" rows="5" />
              </template>
              <template v-if="hasLicenseExport">
                <TextBox title="Consignee" :value.sync="item.consignee" :editor="editor" v-if="isCustomerOrReceiver(item)" length="300" rows="5" />
                <TextBox title="Delivered to" :value.sync="item.deliveredTo" :editor="editor" v-if="isCustomerOrReceiver(item)" length="300" rows="5" />
              </template>
            </template>
          </EditPanel>
        </template>
        <!-- 帳票設定タブ -->
        <template slot="tab6" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 帳票設定タブ 左側 -->
            <template slot="left">
              <AutoComplete title="受注一覧指定帳票" :value.sync="item.salesOrderReportTemplateId" :provider="atcSalesOrderReportQuery" :editor="editor"  tooltip="この得意先向けの帳票を設定しておくことで、【受注一覧】の【帳票＞得意先指定帳票出力】ですぐに出力できます。"/>
              <AutoComplete title="出荷一覧指定帳票" :value.sync="item.salesDeliveryReportTemplateId" :provider="atcSalesDeliveryReportQuery" :editor="editor"  tooltip="この得意先向けの帳票を設定しておくことで、【出荷一覧】の【帳票＞得意先指定帳票出力】ですぐに出力できます。"/>
              <AutoComplete title="請求一覧指定帳票" :value.sync="item.aloneInvoiceReportTemplateId" :provider="atcAloneInvoiceReportQuery" :editor="editor"  tooltip="この得意先向けの帳票を設定しておくことで、【請求一覧】の【帳票＞得意先指定帳票出力】ですぐに出力できます。"/>
            </template>
          </EditPanel>
        </template>
        <!-- 予備項目タブ -->
        <template slot="tab7" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 予備項目タブ 左側 -->
            <template slot="left">
              <TextBox title="voucher_text1" :value.sync="item.reserveText1" :editor="editor" length="50" />
              <TextBox title="voucher_text2" :value.sync="item.reserveText2" :editor="editor" length="50" />
              <TextBox title="voucher_text3" :value.sync="item.reserveText3" :editor="editor" length="50" />
              <TextBox title="voucher_text4" :value.sync="item.reserveText4" :editor="editor" length="50" />
              <TextBox title="voucher_text5" :value.sync="item.reserveText5" :editor="editor" length="50" />
              <TextBox title="voucher_text6" :value.sync="item.reserveText6" :editor="editor" length="50" />
              <AutoComplete title="voucher_list1" :value.sync="item.reserveList1" :editor="editor" path="/master/Category"  list="category_31" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。" />
              <AutoComplete title="voucher_list2" :value.sync="item.reserveList2" :editor="editor" path="/master/Category"  list="category_32" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。" />
              <AutoComplete title="voucher_list3" :value.sync="item.reserveList3" :editor="editor" path="/master/Category"  list="category_33" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。" />
            </template>
            <!-- 予備項目タブ 右側 -->
            <template slot="right">
              <TextBox title="voucher_memo1" :value.sync="item.reserveMemo1" :editor="editor" length="200" rows="4" />
              <TextBox title="voucher_memo2" :value.sync="item.reserveMemo2" :editor="editor" length="200" rows="4" />  
              <TextBox title="voucher_memo3" :value.sync="item.reserveMemo3" :editor="editor" length="200" rows="4" />
            </template>
          </EditPanel>
        </template>
        <!-- ワークフロータブ -->
        <template slot="tab8" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab9" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
// import { Counterpart, CounterpartTypes } from '../../models/All';

@Component
export default class CounterpartView extends Vue {
  public items: Common.Counterpart[] = new Array(0);
  public params: Common.CounterpartQuery = new Common.CounterpartQuery();
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true, true];
  public importQuery = new Common.CounterpartImportQuery('取引先');
  public exportQuery = new Common.CounterpartExportQuery('取引先', this.params);
  public customerFlag = Common.CounterpartTypes.Customer;
  public supplierFlag = Common.CounterpartTypes.Supplier;
  public receiverFlag = Common.CounterpartTypes.Receiver;
  public warehouseFlag = Common.CounterpartTypes.Warehouse;
  public customerOrSupplierFlag = Common.CounterpartTypes.Customer | Common.CounterpartTypes.Supplier;
  public customerOrReceiverFlag = Common.CounterpartTypes.Customer | Common.CounterpartTypes.Receiver;
  public supplierOrWarehouseFlag = Common.CounterpartTypes.Supplier | Common.CounterpartTypes.Warehouse;
  public customerOrSupplierOrWarehouseFlag = Common.CounterpartTypes.Customer | Common.CounterpartTypes.Supplier | Common.CounterpartTypes.Warehouse;
  public tenantSettings: Common.TenantSettings = new Common.TenantSettings();
  public hasLicenseCurrency: boolean = false;
  public hasLicenseImport: boolean = false;
  public hasLicenseExport: boolean = false;
  @Prop() public auditNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  
  @Prop({default:0}) public popupCounterpartTypeDisabled: number;  

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];
  
  public created() {
    //テナント設定をロードする
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicenseImport = this.$api.hasLicense(Common.licenseFlags.import);
    this.hasLicenseExport = this.$api.hasLicense(Common.licenseFlags.export);
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.importQuery.hasLicenseImport = this.hasLicenseImport;
    this.importQuery.hasLicenseExport = this.hasLicenseExport;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseImport = this.hasLicenseImport;
    this.exportQuery.hasLicenseExport = this.hasLicenseExport;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    this.$api.formatter.ensureListLoaded('workflow_masterBase','taxCode');    

  }

  public async onCreate(obj: Common.Counterpart) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.currencyCode = this.tenantSettings.currencyCode;
    //税区分の初期値（課税売上）
    if(this.$api.formatter.getOptions('taxCodeObj').find(obj=> obj.value.name == '課税売上' && obj.value.state == Common.MasterBaseStatus.Posted))
      obj.taxCode = this.$api.formatter.getOptions('taxCodeObj').filter(obj=> obj.value.name == '課税売上' && obj.value.state == Common.MasterBaseStatus.Posted)[0].value.code;
    obj.invoiceType = Common.InvoiceTypes.ConsolidateInvoice;
    obj.closingDate1 = Common.DateTypes.LastDay;
    obj.dueDate1 = Common.DateTypes.LastDay;
    obj.paymentMonth1 = Common.MonthTypes.Month1Later;
    if(this.params != null && this.params.counterpartType != null && this.params.counterpartType != Common.CounterpartTypes.None){
      obj.counterpartType = this.params.counterpartType;
    }
    else if ((this.popupCounterpartTypeDisabled & Common.CounterpartTypes.Customer) == 0) obj.counterpartType = Common.CounterpartTypes.Customer;
    else if ((this.popupCounterpartTypeDisabled & Common.CounterpartTypes.Supplier) == 0)  obj.counterpartType = Common.CounterpartTypes.Supplier;
    else if ((this.popupCounterpartTypeDisabled & Common.CounterpartTypes.Receiver) == 0)  obj.counterpartType = Common.CounterpartTypes.Receiver;
    else if ((this.popupCounterpartTypeDisabled & Common.CounterpartTypes.Warehouse) == 0)  obj.counterpartType = Common.CounterpartTypes.Warehouse;    

    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Counterpart):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public onSelected(index: number, selected: Common.Counterpart) {
    this.onCounterpartTypeChanged(selected);
  }

  public onCounterpartTypeChanged(item: Common.Counterpart) {
    this.$set(this.tabVisibles, 1, this.isCustomer(item)); // 請求設定タブ
    this.$set(this.tabVisibles, 2, this.isSupplierOrWarehouse(item)); // 支払設定タブ    
    this.$set(this.tabVisibles, 3, this.isSupplierOrWarehouse(item)); // 振込連携設定（旧：全銀設定）タブ
    // this.$set(this.tabVisibles, 3, this.isCustomerOrSupplierOrWarehouse(item)); // その他設定タブ=>常に表示
    this.$set(this.tabVisibles, 5, (this.isCustomerOrSupplier(item) || this.isReceiver(item)) && (this.hasLicenseImport || this.hasLicenseExport)); // 貿易書類設定タブ
    this.$set(this.tabVisibles, 6,this.isCustomer(item)); // 帳票設定タブ
    this.$set(this.tabVisibles, 7, this.isCustomerOrSupplier(item) && this.$api.useStockFunction); // 予備項目タブ
    // this.$set(this.tabVisibles, 6, this.isCustomerOrSupplier(item)); // 集計項目タブ
    if(item.counterpartType != this.receiverFlag) item.customer = null;

    //画面項目がない状態で入力エラーの場合、エラーメッセージが表示できずシステムエラーとなるため、不要項目をクリアする
    //得意先以外
    if(item.counterpartType != Common.CounterpartTypes.Customer)
    {
      //請求設定タブ項目をクリア
      item.invoiceType = Common.InvoiceTypes.None;
      item.customerBankAccountCode = null;
      item.payer = null;
      item.payerId = null;
      //その他設定タブ項目をクリア
      item.salesPerson = null;
      item.salesPricingRate = 100;
    }

    if(item.counterpartType != Common.CounterpartTypes.Supplier)
    {
      // 仕入先以外の場合無効な項目を設定
      item.transportation = 0;
      item.shipVia = '';
      item.insurance = '';
      item.shipTo = '';
      item.invoiceNo = '';
    }

    //得意先・仕入先以外
    if(item.counterpartType != Common.CounterpartTypes.Customer && item.counterpartType != Common.CounterpartTypes.Supplier)
    {
      //その他設定タブ項目をクリア
      item.priceCategory = null;
      item.description = '';
      item.category1 = null;
      item.category2 = null;
      item.category3 = null;
      item.category4 = null;
      item.category5 = null;
      item.category6 = null;
      item.remark = '';
      //予備項目タブ項目をクリア
      item.reserveText1 = '';
      item.reserveText2 = '';
      item.reserveText3 = '';
      item.reserveText4 = '';
      item.reserveText5 = '';
      item.reserveText6 = '';
      item.reserveMemo1 = '';
      item.reserveMemo2 = '';
      item.reserveMemo3 = '';
      item.reserveList1 = null;
      item.reserveList2 = null;
      item.reserveList3 = null;
      //貿易設定タブ項目をクリア
      item.commodityName = 0;
      item.deliveryTerm = '';
      item.deliveryLocation = '';
    }

    //仕入先・倉庫以外
    if(item.counterpartType != Common.CounterpartTypes.Supplier && item.counterpartType != Common.CounterpartTypes.Warehouse)
    {
      //支払設定タブ項目をクリア
      item.bankName = '';
      item.bankBranchName = '';
      // item.accountType = '';
      item.accountCategory = Common.BankAccountCategoryTypes.Default;
      item.accountCode = '';
      // item.accountName = '';
      item.payee = null;
      item.payeeId = null;
    }

    //得意先・仕入先・倉庫以外
    if(item.counterpartType != Common.CounterpartTypes.Customer && item.counterpartType != Common.CounterpartTypes.Supplier && item.counterpartType != Common.CounterpartTypes.Warehouse)
    {
      //請求設定タブ・支払設定タブ項目をクリア
      item.paymentDateType = Common.PaymentDateTypes.Monthly;
      item.paymentSite = 0;
      item.closingDate1 = Common.DateTypes.None;
      item.dueDate1 = Common.DateTypes.None;
      item.paymentMonth1 = Common.MonthTypes.None;
      item.closingDate2 = Common.DateTypes.None;
      item.dueDate2 = Common.DateTypes.None;
      item.paymentMonth2 = Common.MonthTypes.None;
      item.paymentTerm = '';
      //その他設定タブ項目をクリア
      item.taxType = Common.TaxTypes.Without;
      item.taxCode = null;
      item.subAccountCode = '';
      item.accountName = '';
      item.currencyCode = null;
    }

    //得意先・納入先以外
    if(item.counterpartType != Common.CounterpartTypes.Customer && item.counterpartType != Common.CounterpartTypes.Receiver)
    {
        if(item.paymentDateType==Common.PaymentDateTypes.None) item.paymentDateType = Common.PaymentDateTypes.Monthly;
        //貿易設定タブ項目をクリア
        item.receiptPlace = '';
        item.loadingPort = '';
        item.dischargePort = '';
        item.deliveryPlace = '';
        item.countryOfDestination = '';
        item.payFreight = '';
        item.consignee = '';
        item.deliveredTo = '';
    }
  }


  public isCustomer(item: Common.Counterpart){
    return item.counterpartType == this.customerFlag;
  }

  public isSupplier(item: Common.Counterpart){
    return item.counterpartType == this.supplierFlag;
  }

  public isReceiver(item: Common.Counterpart){
    return item.counterpartType == this.receiverFlag;
  }

  public isWarehouse(item: Common.Counterpart){
    return item.counterpartType == this.warehouseFlag;
  }

  public isCustomerOrSupplier(item: Common.Counterpart){
    return (item.counterpartType & this.customerOrSupplierFlag) > 0;
  }

  public isCustomerOrReceiver(item: Common.Counterpart){
    return (item.counterpartType & this.customerOrReceiverFlag) > 0;
  }

  public isSupplierOrWarehouse(item: Common.Counterpart){
    return (item.counterpartType & this.supplierOrWarehouseFlag) > 0;
  }

  public isCustomerOrSupplierOrWarehouse(item: Common.Counterpart){
    return (item.counterpartType & this.customerOrSupplierOrWarehouseFlag) > 0;
  }

  public isNotPosted(item: Common.Counterpart){
    return item.state == Common.MasterBaseStatus.NotPosted;
  }

  public paymentDateTypeRequired(item: Common.Counterpart): boolean{
    if(this.isCustomerOrSupplierOrWarehouse(item) == false) return false;
    if(this.isCustomer(item) && item.invoiceType != Common.InvoiceTypes.SeparateInvoice){
      item.paymentDateType = Common.PaymentDateTypes.Monthly;
      return false;
    }
    return true;
  }

  public paymentSiteRequired(item: Common.Counterpart): boolean{
    if(this.isCustomerOrSupplierOrWarehouse(item) == false) return false;
    return item.paymentDateType == Common.PaymentDateTypes.Daily;
  }

  public closingDateRequired(item: Common.Counterpart): boolean{
    if(this.isCustomerOrSupplierOrWarehouse(item) == false) return false;
    return item.paymentDateType == Common.PaymentDateTypes.Monthly;
  }

  public async atcSalesOrderReportQuery():Promise<Common.BindItem[]> {
    return this.atcReportQuery("menu_sales_order");
  }
  public async atcSalesDeliveryReportQuery():Promise<Common.BindItem[]> {
    return this.atcReportQuery("menu_sales_delivery");
  }
  public async atcAloneInvoiceReportQuery():Promise<Common.BindItem[]> {
    return this.atcReportQuery("menu_invoice");
  }
  public async atcReportQuery(viewName:string):Promise<Common.BindItem[]> {
      var bindItems = new Array();
      var query = new Common.ReportTemplateViewQuery();
      query.viewName=viewName;
      await this.$api.execute(query).then(res => {
          var result = res as Common.LoadResult;
          result.result.forEach(obj =>{
            bindItems.push(new Common.BindItem(obj.id,obj.name));
          });
        });
      return Promise.resolve(bindItems);
  }
  public showDownloadImportFile:boolean = false;
  public dlCounterpartType:Common.CounterpartTypes = Common.CounterpartTypes.None;
  public showDownloadImportFileDialog(){
    this.dlCounterpartType = Common.CounterpartTypes.Customer;
    this.showDownloadImportFile = true;
  }
  public onImportFileDownload(){
    let url : string = '';
    switch(this.dlCounterpartType){
      case Common.CounterpartTypes.Customer:
        url = 'https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E5%BE%97%E6%84%8F%E5%85%88(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx';
        break;
      case Common.CounterpartTypes.Supplier:
        url = 'https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E4%BB%95%E5%85%A5%E5%85%88(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx';
        break;
      case Common.CounterpartTypes.Receiver:
        url = 'https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E7%B4%8D%E5%85%A5%E5%85%88(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx';
        break;
      case Common.CounterpartTypes.Warehouse:
        url = 'https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E5%80%89%E5%BA%AB(%E5%8F%96%E5%BC%95%E5%85%88%E3%83%9E%E3%82%B9%E3%82%BF)%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx';
        break;
      default :
        return;
    }
    this.$api.fileDownload(url);
  }
}
</script>

<style lang="scss">
.cx_radio{
  display:block;
}

</style>